import { React, useState, useEffect, View, useRef } from 'react';
import { Box, Paper, Typography, Button } from "@mui/material";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

export default function NewPostModal({ onClose, handleSubmit }) {
  const [post, setPost] = useState("");
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  // Handler for changes in the editor
  const handleEditorChange = (state) => {
    setEditorState(state);
    // Convert content to raw JS object
    const rawContent = convertToRaw(state.getCurrentContent());
    // Convert raw data to HTML (or handle as you need)
    setPost(draftToHtml(rawContent));
  };

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        bgcolor: "rgba(0,0,0,0.4)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1300,
      }}
    >
      <Paper sx={{ p: 4, minWidth: 300, minHeight: 150, position: 'relative' }} elevation={8}>
        <Button
          variant="outlined"
          size="small"
          sx={{ position: 'absolute', top: 16, right: 16 }}
          onClick={onClose}
        >
          Close
        </Button>
        <div style={{paddingTop: 20}}>
          <Editor
            editorState={editorState}
            onEditorStateChange={handleEditorChange}
            wrapperClassName="demo-wrapper"
            editorClassName="demo-editor"
            placeholder="Enter Post"
            editorStyle={{ height: '300px', overflow: 'auto', border: "1px solid #ccc", padding: 10 }}
          />
          <div style={{paddingBottom:10}}><Button onClick={() => {
            handleSubmit(post);
            onClose();
            }} style={{backgroundColor: "#00aaaf", borderColor: "#00aaaf", color: "#fff"}} className="chat-rounded2">Add Post</Button></div>

        </div>
      </Paper>
    </Box>
  );
}